<template>
    <div style="box-sizing: border-box;padding: 20px 0;">
        <div class="rucontent flx alc">
            <div class="svIcon">
                <img :src="$Localimg('succes.png')" alt="" />
            </div>
            <div class="svWord">
                恭喜您，发布成功！请等待平台审核
            </div>
            <div class="qrPart" style="margin-right: 108px;">
                <div class="qrImage">
                    <img :src="$img(info.kefu_qrcode)" alt="" />
                </div>
                <div class="qrname">
                    添加企业微信
                </div>
                <div class="qrdes">
                    了解更多HR行业最新动态
                </div>
            </div>
            <div class="qrPart">
                <div class="qrImage">
                    <img :src="$img(info.gzh_qrcode)" alt="" />
                </div>
                <div class="qrname">
                    及时获取信息进展
                </div>
                <div class="qrdes">
                    请关注“HR新势力”公众号
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getConfig
    } from "@/api/index.js"
    export default {
        name: 'pubSuccess',
        data() {
            return {
                info: {}
            }
        },
        created() {
            let that = this
            getConfig().then((res) => {
                console.log(res)
                if (res.code == 1) {
                    that.info = res.data
                    that.$nextTick(() => {
                        window.scrollTo(0, 0)
                    })
                }
            })
        },
        methods: {

        }
    }
</script>

<style scoped>
    .qrdes {
        margin-top: 8px;
        font-size: 13px;
        color: #4A4A4A;
    }

    .qrPart {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .qrname {
        font-weight: 600;
        font-size: 17px;
        color: #222222;
        text-align: center;
    }

    .qrImage {
        width: 126px;
        height: 130px;
        margin-bottom: 12px;
    }

    .qrImage img {
        width: 100%;
        height: 100%;
    }

    .svIcon {
        width: 54px;
        height: 54px;
    }

    .svWord {
        font-weight: 600;
        font-size: 28px;
        margin-left: 16px;
        margin-right: 235px;
    }

    .svIcon img {
        width: 100%;
        height: 100%;
    }

    .rucontent {
        box-sizing: border-box;
        padding: 0 100px;
        background: #fff;
        width: 1460px;
        height: 280px;
        margin: 0 auto;
    }
</style>